// Components/Layout/AppLayout.jsx
import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from './Components/Private/Header/Header';
import Sidebar from './Components/Private/Sidebar/Sidebar';

const AppLayout = () => {
  return (
    <>
      <Header />
      <Sidebar />
      <main className="main">
        <Outlet />
      </main>
    </>
  );
};

export default AppLayout;
